var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { activeFetchMethod } from "./fetchMethod";
export let pantoneColors;
// Local export for testing purposes
export function setPantoneColors(colors) {
    pantoneColors = colors;
    return pantoneColors;
}
export const fetchPantoneColors = () => __awaiter(void 0, void 0, void 0, function* () {
    pantoneColors = yield activeFetchMethod({
        url: "https://misc-rendering.documents.cimpress.io/pantones?namesOnly=false",
        responseResolver: (response) => __awaiter(void 0, void 0, void 0, function* () { return (yield response.json()); }),
    });
    return pantoneColors;
});
//# sourceMappingURL=pantoneColors.js.map